import { useRealTimeData as _useRealTimeData } from "@foundation/artemis-client";

import { REALTIME_DATA_PROVIDER } from "~constants";
import type { Security } from "~types/types";
import { formatRealTimeData } from "~utils/formatRealTimeData";

export const useRealTimeData = (realTimeTickerDescription?: string) => {
    const rawRealTimeData = _useRealTimeData(
        REALTIME_DATA_PROVIDER.TICKER,
        realTimeTickerDescription || "",
        { usePolling: Boolean(realTimeTickerDescription) }
    );

    if (!rawRealTimeData) {
        return undefined;
    }

    return formatRealTimeData(rawRealTimeData as Security);
};
